import {Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {MAT_SNACK_BAR_DATA} from '@angular/material/snack-bar';
import {ActivatedRoute, Router} from '@angular/router';
import {LocalStorageService} from 'src/app/local-storage.service';
import {MainDataModels} from 'src/app/models/maindata-models';
import {MainDataService} from 'src/app/services/main-data.service';
import {MessageBoxService} from 'src/app/services/message-box.service';
import {SwissSettingsService} from 'src/app/services/swiss-settings.service';
import {TerminEintragComponent} from '../../pendenzen/termin-eintrag/termin-eintrag.component';

export interface TerminEintrag {
  id: string;
  title: string;
  ort: string;
  zeit: string;
  info: string;
}

@Component({
  selector: 'app-termin-liste',
  templateUrl: './termin-liste.component.html',
  styleUrls: ['./termin-liste.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TerminListeComponent implements OnInit {
  private dbTermine?: MainDataModels.Termin[];
  public terminList: TerminEintrag[] = [];
  private storageWebMain: string = 'SwissWebMainDB';
  private aktuelleUhrzeitStunden: number = 0;
  private aktuelleUhrzeitMinuten: number = 0;

  /* Termin bearbeiten */
  private dataForCalendarAppointment?: MainDataModels.TerminMitBenutzer;
  private currTerminMitBenutzern?: MainDataModels.TerminMitBenutzer;
  /* ENDE Termin bearbeiten */

  constructor(
    private svcMainData: MainDataService,
    private localStorageService: LocalStorageService,
    private svcMessageBox: MessageBoxService,
    public dialog: MatDialog,
    private swissSettings: SwissSettingsService,
    private router: Router,
    private route: ActivatedRoute,
    @Inject(MAT_SNACK_BAR_DATA) public data: any
  ) {}

  ngOnInit(): void {
    let jetzt: Date = new Date();
    this.aktuelleUhrzeitStunden = jetzt.getHours();
    this.aktuelleUhrzeitMinuten = jetzt.getMinutes();
    this.loadTermine();
  }

  private loadTermine() {
    // Pendenzen Live vom Webservice holen
    this.svcMainData.getUserTermineHeute().subscribe({
      next: (res) => {
        this.dbTermine = res;
        this.loadListenTermine();
      },
      error: (err) => {
        // Webservice nicht verfügbar --> aus IndexedDB laden
        this.loadTermineFromIndexedDB();
      },
    });
  }

  async loadTermineFromIndexedDB(): Promise<boolean> {
    return this.localStorageService
      .get('termine', this.storageWebMain)
      .then((value) => {
        if (value === false) {
          // Es konnte keinen Wert in der indexeddb für Objekte/Aufträge ermittelt werden
          return false;
        } else {
          // Die Aufträge konnten geladen werden
          if (value) {
            this.dbTermine = <MainDataModels.Termin[]>value;
            this.loadListenTermine();
          }
          console.log('loadPendenzenFromIndexedDB - Ende');
          return true;
        }
      });
  }

  loadListenTermine() {
    if (this.dbTermine) {
      this.terminList = [];

      this.dbTermine.forEach((t) => {
        this.terminList.push({
          id: t.id,
          title: t.description,
          ort: t.location,
          zeit: t.startTime + ' - ' + t.endTime,
          info: this.getZeitBisStart(t),
        });
      });
    }
  }

  getZeitBisStart(termin: MainDataModels.Termin) {
    let result = '';
    let terminStunde: number = Number(termin.startTime?.substring(0, 2));
    let terminMinute: number = Number(termin.startTime?.substring(3, 5));
    if (terminStunde >= this.aktuelleUhrzeitStunden) {
      // Stunden sind gleich
      if (terminStunde === this.aktuelleUhrzeitStunden) {
        if (terminMinute > this.aktuelleUhrzeitMinuten) {
          //Die Minuten sind grösser als die aktuelle
          result =
            'in ' + (terminMinute - this.aktuelleUhrzeitMinuten) + ' Min.';
        }
      } else {
        // Stunden sind nicht gleich
        if (terminMinute >= this.aktuelleUhrzeitMinuten) {
          result =
            'in ' +
            (terminStunde - this.aktuelleUhrzeitStunden) +
            'Std. ' +
            (terminMinute - this.aktuelleUhrzeitMinuten) +
            ' Min.';
        } else {
          if (terminStunde - this.aktuelleUhrzeitStunden - 1 === 0) {
            result =
              'in ' +
              (terminMinute + (60 - this.aktuelleUhrzeitMinuten)) +
              ' Min.';
          } else {
            result =
              'in ' +
              (terminStunde - this.aktuelleUhrzeitStunden - 1) +
              'Std. ' +
              (terminMinute + (60 - this.aktuelleUhrzeitMinuten)) +
              ' Min.';
          }
        }
      }
    }
    return result;
  }

  closeSnackbar() {
    this.data.preClose();
  }

  showTerminList() {
    this.data.preClose();
    this.router.navigate(['/meinetermine']);
  }

  showTerminDetail(eintrag: TerminEintrag) {
    // Termin für das "Wieder-Laden" beim App-Start in IndexedDB speichern
    this.svcMainData.saveChoosedAppointmentToDB(eintrag.id);

    this.svcMainData.loadTerminByID(eintrag.id).subscribe({
      next: (res) => {
        this.dataForCalendarAppointment = res;

        var dialogRef = this.dialog.open(TerminEintragComponent, {
          disableClose: true,
          width: '800px',
          data: this.dataForCalendarAppointment,
        });

        dialogRef.afterClosed().subscribe({
          next: (result) => {
            this.currTerminMitBenutzern = result;
            if (this.currTerminMitBenutzern) {
              // Update Informations
              this.svcMainData
                .saveTermin(this.currTerminMitBenutzern)
                .subscribe({
                  next: (res) => {
                    this.svcMessageBox.showSuccess(
                      'Der Termin wurde erfolgreich aktualisiert.',
                      'Erfolgreich'
                    );
                    this.svcMainData.reloadCalendarData();
                  },
                  error: (error) => {
                    console.log(error);
                    this.svcMessageBox.showError(
                      'Der Termin konnte nicht angepasst werden!!',
                      '!! FEHLER !!'
                    );
                  },
                });
              if (this.swissSettings.getWebConfig().debugMode)
                console.log(
                  'Dialog Resultat (currTerminMitBenutzern): ',
                  this.currTerminMitBenutzern
                );
            }
          },
        });
      },
    });
  }
}
